import client, {MutationOptions, QueryOptions} from "@irati/utils/services/apollo"
import {Homepage, HomepageList} from "@irati/types"
import PBService from "@irati/utils/services"
import {MutationCreateHomepageArgs, MutationUpdateHomepageArgs, QueryHomepagesArgs} from "@irati/types/ops"
import homepageQuery, {homepageListNoDealsKey} from "./queries/homepageListNoDeals"
import homepageByIdNoDeals, {homepageByIdNoDealsKey} from "./queries/homepageByIdNoDeals"
import createHomepage, {createHomepageKey} from "./mutations/createHomepage"
import updateHomepage, {updateHomepageKey} from "./mutations/updateHomepage"

class HomepageService extends PBService {
  list(variables: QueryHomepagesArgs, options: QueryOptions = {}): Promise<HomepageList> {
    return client.query({...options, query: homepageQuery, variables}).then(({data}) => data[homepageListNoDealsKey])
  }

  getHomepage = (id: string, options: QueryOptions = {}): Promise<Homepage> => {
    const variables = {id}
    return client.query({...options, query: homepageByIdNoDeals, variables}).then(({data}) => {
      return data[homepageByIdNoDealsKey]
    })
  }

  createHomepage(variables: MutationCreateHomepageArgs, options: MutationOptions = {}): Promise<Homepage> {
    return client.mutate({...options, mutation: createHomepage, variables}).then(({data: responseData}) => {
      return responseData[createHomepageKey]
    })
  }

  updateHomepage(variables: MutationUpdateHomepageArgs, options: MutationOptions = {}): Promise<Homepage> {
    return client.mutate({...options, mutation: updateHomepage, variables}).then(({data: responseData}) => {
      return responseData[updateHomepageKey]
    })
  }
}

const homepageService = new HomepageService({errorHandlers: []})
export default homepageService
